import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { MDBBtn, MDBContainer, MDBIcon } from 'mdb-react-ui-kit'
import MessagesList from './components/MessagesList/MessagesList.component'
import MessageForm from './components/MessageForm/MessageForm.component'
import MessagingStore from './../Messaging.store'
import UserProfileService from './../../../shared/services/UserProfile.service'

import './MessageEditor.scss'

class MessageEditor extends Component {
  state = {
    isEditing: false,
    isCreating: false,
    messageId: null,
    canCreate: false,
  }

  get isEnabled() {
    return (
      UserProfileService.isA(['internal-admin', 'system-admin', 'agency-owner']) ||
      (parseInt(this.props?.division_id, 10) > 0 && UserProfileService.isA('divisional-leader'))
    )
  }

  createForm = () => (
    <MessageForm
      onSubmit={reload => this.formCompleted(reload)}
      division_id={this.props?.division_id}
      category={this.props?.category}
    />
  )

  editForm = () => (
    <MessageForm
      onSubmit={reload => this.formCompleted(reload)}
      division_id={this.props?.division_id}
      msgId={this.state.messageId}
      category={this.props?.category}
    />
  )

  onEdit = msgId => this.setState({ isCreating: false, isEditing: true, messageId: msgId })

  onCreate = () => this.setState({ isCreating: true, isEditing: false })

  formCompleted = savedCategory => {
    this.setState({ isCreating: false, isEditing: false })

    if (savedCategory) {
      // savedCategory is the actual category string from the form, or true as fallback
      const cat = typeof savedCategory === 'string' ? savedCategory : this.props?.category

      if (cat && cat !== 'division') {
        MessagingStore.hasFetched[cat] = false
        MessagingStore.fetchMessagesByCategory(cat, this.props?.division_id)
      } else if (cat === 'division') {
        MessagingStore.fetchMessagesByCategory(cat, this.props?.division_id)
      } else {
        // fallback — bust both non-division caches
        MessagingStore.hasFetched.dashboard = false
        MessagingStore.hasFetched.leader = false
      }
    }
  }

  renderHeader = () => {
    if (this.props?.hideHeader) {
      if (!this.state.isEditing && !this.state.isCreating && this.state.canCreate) {
        return (
          <div
            style={{
              zIndex: 1,
              position: 'absolute',
              right: '20px',
              top: '30px',
            }}
          >
            <MDBBtn
              type='button'
              color='default'
              tag='a'
              gradient='blue'
              title={'Add New Message'}
              onClick={() => this.onCreate()}
            >
              <MDBIcon icon='plus' /> Create New Message
            </MDBBtn>
          </div>
        )
      }
      return <></>
    }

    return (
      <>
        <h2>
          {this.state.isCreating
            ? 'Create New Message'
            : this.state.isEditing
            ? 'Update Message'
            : 'Message Administration'}
          {!this.state.isEditing && !this.state.isCreating && this.state.canCreate && (
            <div className='d-inline-block'>
              <MDBBtn
                type='button'
                color='default'
                tag='a'
                floating
                gradient='blue'
                title={'Add New Message'}
                onClick={() => this.onCreate()}
              >
                <MDBIcon icon='plus' />
              </MDBBtn>
            </div>
          )}
        </h2>
        <hr />
      </>
    )
  }

  renderMessageComponent = () => {
    if (this.state.isCreating) return this.createForm()

    if (this.state.isEditing) return this.editForm()

    return (
      <MessagesList
        onEdit={msgId => this.onEdit(msgId)}
        division_id={this.props?.division_id}
        category={this.props?.category}
      />
    )
  }

  checkUserCanModifyMessages = async () => {
    try {
      this.setState({
        canCreate:
          (this.props?.category === 'leaders' &&
            UserProfileService.isA(['agency-owner', 'internal-admin', 'internal-staff', 'system-admin'], true)) ||
          UserProfileService.canUser('messages.dashboard.create'),
      })
    } catch (ex) {
      console.error('ERROR: Failed to check user permissions in MessageEditor.  ', ex)
    }
  }

  componentDidMount() {
    this.checkUserCanModifyMessages()

    const queryParams = new URLSearchParams(this.props.location.search),
      id = queryParams.get('id')
    if (id) this.onEdit(id)
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.division_id !== this.props?.division_id) {
      this.setState({ isEditing: false, isCreating: false, messageId: null })
    }
  }

  render() {
    if (!this.isEnabled) return <></>

    return (
      <MDBContainer fluid className='mt-0'>
        {this.renderHeader()}
        {this.renderMessageComponent()}
      </MDBContainer>
    )
  }
}

export default withRouter(MessageEditor)
